(function () {
  'use strict';

  const OPTION_ORDER = ['Material', 'Frame', 'Size'];

  const FRAME_SWATCHES = {
    'Unframed': 'background: repeating-linear-gradient(45deg, #ccc 0, #ccc 2px, #fff 2px, #fff 6px); border: 0.5px solid #ccc;',
    'Black':    'background: #1a1a1a;',
    'White':    'background: #f0ede8; border: 0.5px solid #ccc;',
    'Natural':  'background: #FBE3BF;',
    'Brown':    'background: #8B5E3C;'
  };

  function getOptionName(fs) {
    const legend = fs.querySelector('legend, .form__label, label');
    if (!legend) return '';
    return legend.textContent.trim().split(':')[0].trim().split('\n')[0].trim();
  }

  function init() {
    const pickers = document.querySelectorAll('variant-picker');
    if (!pickers.length) return;
    pickers.forEach(function (picker) {
      setupPicker(picker);
      observePicker(picker);
    });
  }

  // ── Watch for Horizon re-renders ─────────────────────────────────────────
  function observePicker(picker) {
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        // If our custom UI was removed, rebuild it
        if (!picker.querySelector('[data-cvp]')) {
          setupPicker(picker);
          return;
        }
        // If new fieldsets appeared (Horizon re-rendered), rebuild
        for (const node of mutation.addedNodes) {
          if (node.nodeName === 'FIELDSET' ||
              (node.nodeType === 1 && node.querySelector('fieldset'))) {
            // Remove old custom UI first
            const old = picker.querySelector('[data-cvp]');
            if (old) old.remove();
            setupPicker(picker);
            return;
          }
        }
      }
    });

    observer.observe(picker, {
      childList: true,
      subtree: true
    });
  }

  function setupPicker(picker) {
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
if (!fieldsets.length) return;

// Don't run twice
if (picker.querySelector('[data-cvp]')) return;

// Only run on products with artwork options; skip gift cards etc.
const optionNames = fieldsets.map(function (fs) { return getOptionName(fs); });
const hasArtworkOptions = OPTION_ORDER.some(function (o) { return optionNames.includes(o); });
if (!hasArtworkOptions) {
  fieldsets.forEach(function (fs) {
    fs.style.setProperty('display', 'block', 'important');
  });
  return;
}

    // Map option name → fieldset
    const optionMap = {};
    fieldsets.forEach(function (fs) {
      const name = getOptionName(fs);
      if (name) optionMap[name] = fs;
    });

    // Hide native fieldsets
    fieldsets.forEach(function (fs) {
      fs.style.display = 'none';
    });

    // Build custom UI
    const container = document.createElement('div');
    container.className = 'cvp';
    container.setAttribute('data-cvp', '');

    OPTION_ORDER.forEach(function (optionName) {
      const fieldset = optionMap[optionName];
      if (!fieldset) return;

      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;

      const group = document.createElement('div');
      group.className = 'cvp__group';
      group.setAttribute('data-option', optionName);

      // Label row
      const labelRow = document.createElement('div');
      labelRow.className = 'cvp__label-row';

      const labelWrap = document.createElement('div');
      labelWrap.className = 'cvp__label-wrap';

      const label = document.createElement('span');
      label.className = 'cvp__label';
      label.textContent = optionName + ':';
      labelWrap.appendChild(label);

      if (optionName === 'Size') {
        // Size: show dimensions inline next to label
        const dimDisplay = document.createElement('span');
        dimDisplay.className = 'cvp__selected-label';
        dimDisplay.setAttribute('data-dim-display', '');
        labelWrap.appendChild(dimDisplay);
      } else {
        // Material and Frame: show selected value next to label
        const selectedLabel = document.createElement('span');
        selectedLabel.className = 'cvp__selected-label';
        selectedLabel.setAttribute('data-selected-label', optionName);
        labelWrap.appendChild(selectedLabel);
      }

      labelRow.appendChild(labelWrap);

      // Compare all sizes on the right for Size
     if (optionName === 'Size') {
      const compareLink = document.createElement('button');
      compareLink.type = 'button';
      compareLink.className = 'cvp__compare-link cvp__compare-badge';
      compareLink.setAttribute('data-csg-trigger', '');
      compareLink.textContent = 'Compare sizes';
      labelRow.appendChild(compareLink);
    }

      group.appendChild(labelRow);

      // Options
      const optionsRow = document.createElement('div');
      optionsRow.className = optionName === 'Frame' ? 'cvp__swatches' : 'cvp__pills';

      inputs.forEach(function (input) {
        const value = input.value;
        const isChecked = input.checked;
        const isDisabled = input.disabled || input.classList.contains('disabled');

        if (optionName === 'Frame') {
          const swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'cvp__swatch' +
            (isChecked ? ' is-active' : '') +
            (isDisabled ? ' is-disabled' : '');
          swatch.setAttribute('data-value', value);
          swatch.setAttribute('data-option', optionName);
          swatch.setAttribute('aria-label', value);
          swatch.setAttribute('title', value);
          const swatchStyle = FRAME_SWATCHES[value];
          if (swatchStyle) swatch.setAttribute('style', swatchStyle);
          if (!isDisabled) {
            swatch.addEventListener('click', function () {
              selectOption(picker, optionName, value, container);
            });
          }
          optionsRow.appendChild(swatch);
        } else {
          const pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'cvp__pill' +
            (isChecked ? ' is-active' : '') +
            (isDisabled ? ' is-disabled' : '');
          pill.setAttribute('data-value', value);
          pill.setAttribute('data-option', optionName);
          pill.textContent = value;
          if (!isDisabled) {
            pill.addEventListener('click', function () {
              selectOption(picker, optionName, value, container);
            });
          }
          optionsRow.appendChild(pill);
        }
      });

      group.appendChild(optionsRow);
      container.appendChild(group);
    });

    // Insert before first fieldset
    const firstFieldset = fieldsets[0];
    if (firstFieldset && firstFieldset.parentNode) {
      firstFieldset.parentNode.insertBefore(container, firstFieldset);
    } else {
      picker.appendChild(container);
    }

    // Set initial state
    updateLabelsAndDims(picker, container);

    // Sync on any native change
    picker.addEventListener('change', function () {
      syncActiveStates(picker, container);
      updateLabelsAndDims(picker, container);
    });
  }

  function selectOption(picker, optionName, value, container) {
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    fieldsets.forEach(function (fs) {
      if (getOptionName(fs) !== optionName) return;
      const input = fs.querySelector('input[value="' + CSS.escape(value) + '"]');
      if (input && !input.disabled) input.click();
    });
    syncActiveStates(picker, container);
    updateLabelsAndDims(picker, container);
  }

  function syncActiveStates(picker, container) {
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    fieldsets.forEach(function (fs) {
      const name = getOptionName(fs);
      const inputs = Array.from(fs.querySelectorAll('input[type="radio"]'));
      inputs.forEach(function (input) {
        const btn = container.querySelector(
          '[data-option="' + CSS.escape(name) + '"][data-value="' + CSS.escape(input.value) + '"]'
        );
        if (!btn) return;
        btn.classList.toggle('is-active', input.checked);
        btn.classList.toggle('is-disabled', input.disabled || input.classList.contains('disabled'));
      });
    });
  }

  function updateLabelsAndDims(picker, container) {
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    fieldsets.forEach(function (fs) {
      const name = getOptionName(fs);
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      if (name === 'Size') {
        const dimDisplay = container.querySelector('[data-dim-display]');
        if (!dimDisplay) return;
        const sizeGuideData = document.querySelector('[data-size-dimensions]');
        if (!sizeGuideData) return;
        try {
          const dims = JSON.parse(sizeGuideData.textContent);
          dimDisplay.textContent = dims[checked.value] ? ' ' + dims[checked.value] : '';
        } catch (e) {
          dimDisplay.textContent = '';
        }
      } else {
        const selectedLabel = container.querySelector('[data-selected-label="' + name + '"]');
        if (selectedLabel) selectedLabel.textContent = ' ' + checked.value;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();